import _ from 'lodash';
import moment from 'moment';
import initialState from './customerInitialState';
import mutations from './customerMutation';
import actions from './customerAction';

const getters = {
  notOnboardedTableData: (state) => {
    const { notOnboardedCustomers } = state;

    if (notOnboardedCustomers.length) {
      return notOnboardedCustomers.map((c) => {
        const obj = _.cloneDeep(c);
        if (c.shippingAddress) {
          obj.name = `${c.shippingAddress.firstName} ${c.shippingAddress.lastName}` || '--';
          obj.email = c.shippingAddress.email || '--';
          obj.zip = c.shippingAddress.zip || '--';
        }
        obj.key = Math.random() * 1000000;
        obj.orderDate = moment(c.orderDate).format('YYYY-MM-DD');
        return obj;
      });
    }
    return [];
  },
};

const customerModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default customerModule;
